import { Merchant } from 'steplix-emv-qrcps';

const PIX_KEY_TYPE = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  CPNJ: 'CPNJ',
  CPF: 'CPF',
};

export const formatPixKey = (key: string, keyType: string) => {
  let rkey = key.toUpperCase();

  if (
    keyType === PIX_KEY_TYPE.PHONE ||
    keyType === PIX_KEY_TYPE.CPNJ ||
    keyType === PIX_KEY_TYPE.CPF
  ) {
    rkey = rkey.replace(/\D/g, '');
  }

  if (keyType === PIX_KEY_TYPE.PHONE) {
    rkey = `+55${rkey}`;
  }

  return rkey;
};

export type BRCodeStatic = {
  key: string;
  amount?: string;
  name?: string;
  reference?: string;
  city?: string;
  zipcode?: string;
};
export const generateBRCodeStatic = ({
  key,
  amount,
  name,
  reference,
  city = 'Sao Paulo',
  zipcode,
}: BRCodeStatic) => {
  const emvqr = Merchant.buildEMVQR();

  emvqr.setPayloadFormatIndicator('01');
  emvqr.setCountryCode('BR');
  emvqr.setMerchantCategoryCode('0000');
  emvqr.setTransactionCurrency('986');
  const merchantAccountInformation = Merchant.buildMerchantAccountInformation();

  merchantAccountInformation.setGloballyUniqueIdentifier('BR.GOV.BCB.PIX');

  const paymentSystemSpecific = Merchant.buildPaymentSystemSpecific();

  paymentSystemSpecific.setGloballyUniqueIdentifier('BR.GOV.BCB.BRCODE');
  paymentSystemSpecific.addPaymentSystemSpecific('01', '1.0.0');

  merchantAccountInformation.addPaymentNetworkSpecific('01', key);

  emvqr.addMerchantAccountInformation('26', merchantAccountInformation);

  if (name) {
    emvqr.setMerchantName(name.toUpperCase());
  }

  if (amount && amount !== '') {
    emvqr.setTransactionAmount(amount);
  }

  emvqr.setMerchantCity(city); // 60;
  if (zipcode) {
    emvqr.setPostalCode(zipcode); // 61
  }

  const additionalDataFieldTemplate =
    Merchant.buildAdditionalDataFieldTemplate();

  if (reference) {
    additionalDataFieldTemplate.setReferenceLabel(reference.slice(0, 25));
  } else {
    additionalDataFieldTemplate.setReferenceLabel('***');
  }

  additionalDataFieldTemplate.addPaymentSystemSpecific(
    '50',
    paymentSystemSpecific,
  );
  emvqr.setAdditionalDataFieldTemplate(additionalDataFieldTemplate);

  return emvqr.generatePayload();
};
